import { render, staticRenderFns } from "./detail.page.vue?vue&type=template&id=25ddd007&scoped=true&"
import script from "./detail.page.vue?vue&type=script&lang=js&"
export * from "./detail.page.vue?vue&type=script&lang=js&"
import style0 from "./detail.page.vue?vue&type=style&index=0&id=25ddd007&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ddd007",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25ddd007')) {
      api.createRecord('25ddd007', component.options)
    } else {
      api.reload('25ddd007', component.options)
    }
    module.hot.accept("./detail.page.vue?vue&type=template&id=25ddd007&scoped=true&", function () {
      api.rerender('25ddd007', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trade/comment/detail.page.vue"
export default component.exports